import {
	newKeyResultForm
} from "../forms";

export const pristineState = i18n => ( {
	selectedPanel: "details",
	isBusy: false,
	isDisabled: false,
	saveAttempted: false,
	/** formId.fieldName:startPosition **/
	focusedField: "",
	parentGoal: {
		goalId: "",
		title: "",
		plannedStartDate: "",
		plannedFinishDate: "",
		keyResults: [],
	},
	assignedTeam: {
		teamId: "",
		name: "",
		members: [],
	},
	keyResultForm: newKeyResultForm( {}, i18n ),
	goalActivity: [],
	activityComment: "",
} );
